import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { PaginatedTrueWalletTransactionLogsResponse } from '../../types'
import { columns } from './constants'
import { Button } from '@/common/ui/button'
import { Icons } from '@/common/ui/icons'
import { RefetchOptions } from '@tanstack/react-query'
import { Input } from '@/common/ui/input'
import { useState } from 'react'
import { useQueryState } from 'nuqs'

interface TrueWalletLogsTableProps {
	data: PaginatedTrueWalletTransactionLogsResponse['data']
	total: number
	onRefresh: (options?: RefetchOptions) => Promise<unknown>
	isLoading?: boolean
}

export default function TrueWalletLogsTable({
	data,
	total,
	onRefresh,
	isLoading,
}: TrueWalletLogsTableProps) {
	const [localPhoneNumber, setLocalPhoneNumber] = useState('')
	const [localAmount, setLocalAmount] = useState('')

	const [phoneNumber, setPhoneNumber] = useQueryState('phoneNumber')
	const [amount, setAmount] = useQueryState('amount')

	const handleSearch = () => {
		setPhoneNumber(localPhoneNumber || null)
		setAmount(localAmount || null)
	}

	const handleClear = () => {
		setLocalPhoneNumber('')
		setLocalAmount('')
		setPhoneNumber(null)
		setAmount(null)
	}

	const hasFilters = phoneNumber || amount

	return (
		<div className="space-y-4">
			{/* Filter Controls - Mobile Responsive */}
			<div className="space-y-4">
				{/* Filter Controls Row */}
				<div className="flex flex-col gap-4 sm:flex-row sm:flex-wrap sm:items-center sm:gap-4">
					<Input
						placeholder="ค้นหาเบอร์โทรศัพท์"
						value={localPhoneNumber}
						onChange={(e) => setLocalPhoneNumber(e.target.value)}
						className="h-8 w-full sm:h-9 sm:w-auto sm:min-w-[200px]"
						onKeyDown={(e) => {
							if (e.key === 'Enter') handleSearch()
						}}
					/>

					<Input
						placeholder="ค้นหาจำนวนเงิน"
						type="number"
						value={localAmount}
						onChange={(e) => setLocalAmount(e.target.value)}
						className="h-8 w-full sm:h-9 sm:w-auto sm:min-w-[200px]"
						onKeyDown={(e) => {
							if (e.key === 'Enter') handleSearch()
						}}
					/>

					<Button
						onClick={handleSearch}
						size="sm"
						className="h-8 px-3 text-xs sm:h-9 sm:px-4 sm:text-sm"
					>
						ค้นหา
					</Button>

					{hasFilters && (
						<Button
							variant="outline"
							size="sm"
							onClick={handleClear}
							className="h-8 px-3 text-xs sm:h-9 sm:px-4 sm:text-sm"
						>
							ล้าง
						</Button>
					)}

					<Button
						variant="outline"
						size="sm"
						onClick={() => onRefresh()}
						title="รีเฟรชข้อมูล"
						className="h-8 w-8 sm:h-9 sm:w-9"
					>
						<Icons.refresh className="h-4 w-4" />
					</Button>
				</div>
			</div>

			{/* Table */}
			<DataTablePaginate
				columns={columns}
				data={data}
				totalItems={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
